import axios from 'axios';
import { useEffect, useRef } from 'react';

const INTERVAL_TIME = 30 * 60 * 1000;

const useRefreshTokenInterval = ({ auth, interval = INTERVAL_TIME, onRefreshFailed, onRefreshed }) => {
    const intervalRef = useRef(null);
    const inFlightRef = useRef(false);

    useEffect(() => {
        if (!auth?.user_id) return;

        const refreshToken = async () => {
            if (inFlightRef.current) return;

            const refreshTokenValue = localStorage.getItem('refresh_token');
            if (!refreshTokenValue) return;

            // 👉 NEW: check last refreshed time
            const lastRefreshedAt = Number(localStorage.getItem('last_refreshed_at') || 0);
            const now = Date.now();

            if (now - lastRefreshedAt < interval) {
                return; // skip, still fresh
            }

            inFlightRef.current = true;
            try {
                const resp = await axios.post('/get-refresh-token', {
                    code: refreshTokenValue,
                    course_id: auth.course_id,
                });

                const data = resp;

                if (!data?.access_token) throw new Error('Missing access_token from refresh response');

                localStorage.setItem('access_token', data.access_token);

                if (data.refresh_token) {
                    localStorage.setItem('refresh_token', data.refresh_token);
                }

                // 👉 NEW: store timestamp
                localStorage.setItem('last_refreshed_at', Date.now().toString());

                onRefreshed?.(data);
            } catch (e) {
                onRefreshFailed?.(e);
            } finally {
                inFlightRef.current = false;
            }
        };

        refreshToken();

        intervalRef.current = setInterval(refreshToken, interval);

        return () => {
            clearInterval(intervalRef.current);
        };
    }, [auth?.course_id, auth?.user_id, interval, onRefreshFailed, onRefreshed]);
};

export default useRefreshTokenInterval;
